<template>
  <v-container fluid>
  <span>Countries</span>
    <v-text-field
      ref="searchTextBox"
      v-model="search" outlined clearable
      append-icon="mdi-magnify"
      label="Search"
      @keyup="onSearchKeyUp($event)"
      class="mx-0 mt-4 mb-0 pa-0 pb-0"
    ></v-text-field>
    <v-data-table
      dense
      :headers="headers"
      :items="items"
      item-key="Id" 
      display-text="CountryName"
      class="elevation-1"
      :search="search"
      @click:row="onClickRow($event)"
      :items-per-page="itemsPerPage"
      hide-default-footer
    >
    <template slot="no-data" v-if="loading == true">Loading data...</template>
    <template slot="no-data" v-if="loading == false">No records found.</template>
    </v-data-table>
    <v-overlay opacity="0" v-if="loading">
      <v-progress-circular
        indeterminate
        color="red"
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-container>
</template>
<style lang="scss">
</style>
<script>
import api from '@/api.js';

export default {
  name: "countries-view",

  props: {
  },

  data: () => ({
    loading: false,
    itemsPerPage: -1,
    items: [],
    headers: [],
    search: null
  }),

  async created() {
    const me = this;
    me.headers = me.createHeaders();
    me.refresh();
  },

  updated() {
    document.title = "Jura Orga App | Countries";
  },

  methods: {
    async refresh() {
       const me = this;
       me.loading = true;
       const res = await api.get(`Countries`);
       me.items = res.data;
       me.loading = false;
    },

    addNew() {
      this.$router.push(`countries/-1`);
    },

    onClickRow(e) {
      this.$router.push(`countries/${e.Id}`);
    },

    createHeaders() {
      //const me = this;
      const headers = [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "CountryName",
        },
      ];
      return headers;
    },
  },
};
</script>